import { LocaleUser } from '../en/user'

const user: LocaleUser = {
  changePass: '更換密碼',
  editProfile: '編輯個人主頁',
  emailVerifiedSuccess: '電子郵箱已驗證',
  emailCantVerified: '您的電子郵箱無法驗證',
  changeLang: '改變語言',
  english: '英語',
  vietnamese: '越南語',
  chineseSimplified: '簡體中文',
  spanish: '西班牙語',
  chineseTraditional: '繁體中文',
  malay: '馬來語',
}

export default user
